/**
 * Module constants matching the backend Module enum
 */
const Module = {
  QA_KNOWLEDGE_BASE: "qa_knowledge_base",
  RAG_KNOWLEDGE_BASE: "rag_knowledge_base",
  STRUCTURED_DATA: "structured_data",
  ACRM: "acrm",
  INTEGRATION_SG_CLINIC_ASSIST: "integration_sg_clinic_assist",
  PORTAL_APPOINTMENT: "portal.appointment",
  PORTAL_IMPORT: "portal.import",
  PORTAL_TOOLBOX: "portal.toolbox",
  PORTAL_ANALYTICS: "portal.analytics",
  PORTAL_COEX: "portal.coex",
  PORTAL_MCTB: "portal.mctb",
};

/**
 * Descriptions for each module to be displayed in the UI
 */
export const ModuleDescriptions = {
  [Module.QA_KNOWLEDGE_BASE]: "Enables the QA Knowledge Base tab for managing frequently asked questions and their answers. Use this for creating a knowledge base of common questions that can be used by the AI assistant.",
  [Module.RAG_KNOWLEDGE_BASE]: "Enables the RAG Knowledge Base tab for managing vector-based knowledge retrieval. This uses the QA knowledge base as the source of truth and generates vectors for enhanced AI responses.",
  [Module.STRUCTURED_DATA]: "Uses structured data instead of documents to retrieve doctors, schedules, and other information. This provides more accurate and up-to-date information.",
  [Module.ACRM]: "Agent CRM module (tailored)",
  [Module.INTEGRATION_SG_CLINIC_ASSIST]: "Enables integration with external Clinic Assistant API for handling tool calls. When activated, tool calls will be processed through the Clinic Assistant API instead of the default system.",
  [Module.PORTAL_APPOINTMENT]: "Enables portal appointment functionality for patients to book and manage appointments through the patient portal interface.",
  [Module.PORTAL_IMPORT]: "Enables portal import functionality for importing and managing data through the patient portal interface.",
  [Module.PORTAL_TOOLBOX]: "Enables portal toolbox functionality for managing tools and utilities through the patient portal interface.",
  [Module.PORTAL_ANALYTICS]: "Enables portal analytics functionality for viewing analytics, conversation activities, and Meta WhatsApp templates through the patient portal interface.",
  [Module.PORTAL_COEX]: "Enables portal coex functionality for embedded signup through the patient portal interface.",
  [Module.PORTAL_MCTB]: "Enables portal MCTB functionality through the patient portal interface.",
};

export default Module;
